import * as React from 'react';
import { useGetProviderQuery } from "../../../apis/Provider.api";
import { PrimaryProvider, Provider } from "../../../types/models/Provider";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: Provider;
};

export const ProviderNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const ProviderName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetProviderQuery(PrimaryProvider.fromId(id))
    return (<ProviderNameDisplay data={data}/>)
}

export default ProviderName;
